import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const classData = {
  Physics: {
    2026: [
      "Sunday: 7.00 p.m. - 8.30 p.m.",
      "Thursday: 7.00 p.m. - 8.30 p.m.",
      "Friday: 7.00 p.m. - 8.30 p.m.",
      "Saturday: 7.00 p.m. - 8.30 p.m.",
    ],
    2027: [
      "Monday: 6.00 p.m. - 7.30 p.m.",
      "Tuesday: 6.00 p.m. - 7.30 p.m.",
      "Wednesday: 6.00 p.m. - 7.30 p.m.",
      "Thursday: 5.45 p.m. - 7.00 p.m.",
    ],
    2028: [
      "Friday: 5.30 p.m. - 7.00 p.m.",
      "Saturday: 5.30 p.m. - 7.00 p.m.",
      "Sunday: 5.30 p.m. - 7.00 p.m.",
    ],
  },
  Chemistry: {
    2026: [
      "Monday: 7.00 p.m. - 8.30 p.m.",
      "Tuesday: 7.00 p.m. - 8.30 p.m.",
      "Wednesday: 7.00 p.m. - 8.30 p.m.",
    ],
    2027: [
      "Sunday: 7.00 p.m. - 8.30 p.m.",
      "Thursday: 7.00 p.m. - 8.30 p.m.",
      "Friday: 7.00 p.m. - 8.30 p.m.",
    ],
    2028: [
      "Monday: 5.00 p.m. - 6.30 p.m.",
      "Wednesday: 5.00 p.m. - 6.30 p.m.",
    ],
  },
};

const ClassesPage = () => {
    useEffect(() => {
      const NUM_BALLS = 18;
      const balls = [];
      const colors = [
        "#f1f5ff", // very light blue
        "#a5b4fc", // soft indigo
        "#fcd34d", // soft yellow
        "#fca5a5", // soft red
        "#6ee7b7", // soft green
        "#f9a8d4", // soft pink
        "#c7d2fe", // blue-gray
        "#fff"
      ];
      const container = document.getElementById("randomBallsBg");
      if (!container) return;
      container.innerHTML = "";
      const footer = document.querySelector("footer");
      let footerHeight = 0;
      if (footer) {
        footerHeight = footer.offsetHeight;
      }
      const W = window.innerWidth;
      const H = window.innerHeight - footerHeight;
      for (let i = 0; i < NUM_BALLS; i++) {
        const ball = document.createElement("div");
        const size = Math.random() * 18 + 12;
        ball.className = "random-ball";
        ball.style.width = `${size}px`;
        ball.style.height = `${size}px`;
        ball.style.background = colors[Math.floor(Math.random() * colors.length)];
        ball.style.left = `${Math.random() * (W - size)}px`;
        ball.style.top = `${Math.random() * (H - size)}px`;
        container.appendChild(ball);
        balls.push({
          el: ball,
          x: parseFloat(ball.style.left),
          y: parseFloat(ball.style.top),
          dx: (Math.random() - 0.5) * 1.5,
          dy: (Math.random() - 0.5) * 1.5,
          size,
        });
      }
      let running = true;
      function animate() {
        if (!running) return;
        for (const b of balls) {
          b.x += b.dx;
          b.y += b.dy;
          if (b.x < 0 || b.x > W - b.size) b.dx *= -1;
          if (b.y < 0 || b.y > H - b.size) b.dy *= -1;
          b.x = Math.max(0, Math.min(W - b.size, b.x));
          b.y = Math.max(0, Math.min(H - b.size, b.y));
          b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
        }
        requestAnimationFrame(animate);
      }
      animate();
      return () => {
        running = false;
        if (container) container.innerHTML = "";
      };
    }, []);
  const [selectedSubject, setSelectedSubject] = useState("Physics");
  const [selectedBatch, setSelectedBatch] = useState(2026);

  return (
    <div className="relative min-h-screen overflow-hidden flex justify-center px-1 py-15 bg-lightblue">
      {/* Animated Random Balls Background */}
      <div className="random-balls-bg" id="randomBallsBg"></div>
      {/* Main Content */}
      <div className="relative w-full max-w-6xl flex flex-col items-center space-y-10 mt-10">

        {/* Animated Quote */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="flex flex-col items-center justify-center text-center px-4"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            "Unlock Your Potential Through Knowledge"
          </h2>
          <p className="text-lg md:text-xl text-gray-600">
            Join our Physics and Chemistry classes to reach new heights!
          </p>
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="text-3xl font-extrabold text-gray-800 text-center drop-shadow-md"
        >
          <span className="text-primary">Explore</span> Our Classes
        </motion.h1>

        {/* Subject Selection */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 1 }}
          className="flex flex-wrap justify-center gap-4 sm:gap-6"
        >
          {["Physics", "Chemistry"].map((subject) => (
            <button
              key={subject}
              onClick={() => setSelectedSubject(subject)}
              className={`px-6 py-2 sm:px-8 sm:py-3 rounded-full font-semibold transition-all duration-300 border-2 ${
                selectedSubject === subject
                  ? "bg-primary text-white border-primary shadow-lg"
                  : "bg-white bg-opacity-70 text-gray-700 hover:bg-primary border-primary"
              } hover:scale-105`}
            >
              {subject}
            </button>
          ))}
        </motion.div>

        {/* Batch Selection */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
          className="flex flex-wrap justify-center gap-4 sm:gap-6"
        >
          {[2026, 2027, 2028].map((batch) => (
            <button
              key={batch}
              onClick={() => setSelectedBatch(batch)}
              className={`px-6 py-2 sm:px-8 sm:py-3 rounded-full font-semibold transition-all duration-300 border-2 ${
                selectedBatch === batch
                  ? "bg-primary text-white border-primary shadow-lg"
                  : "bg-white bg-opacity-70 text-gray-700 hover:bg-primary border-primary"
              } hover:scale-105`}
            >
              Batch {batch}
            </button>
          ))}
        </motion.div>

        {/* Class Time List */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1, duration: 1 }}
          className="w-full max-w-3xl bg-white bg-opacity-70 backdrop-blur-md p-8 rounded-3xl shadow-xl transition-all duration-500 mr-5 ml-5"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-6">
            {selectedSubject} - G.C.E A/L {selectedBatch}
          </h2>
          <ul className="space-y-4 text-gray-700 text-lg sm:text-xl">
            {classData[selectedSubject][selectedBatch].map((time, index) => (
              <li
                key={index}
                className="flex items-center gap-2 hover:text-indigo-600 transition duration-300"
              >
                <span className="text-indigo-400 text-xl">•</span> {time}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  );
};

export default ClassesPage;
